function dispatchCustomEvent(event, detail) {
	if (
		$("html").hasClass("lt-ie10") ||
		$("html").hasClass("is-ie10") ||
		$("html").hasClass("is-ie11")
	) {
		var newEvent = document.createEvent("CustomEvent");
		newEvent.initCustomEvent(event, true, true, detail);
		window.dispatchEvent(newEvent);
	} else {
		window.dispatchEvent(
			new CustomEvent(event, {
				detail: detail
			})
		);
	}
}

function Util() {
	this.findHierarchyStringInObject = function(object, pathString, delimiter) {
		var keys = pathString.split(delimiter);
		return this.findHierarchyArrayInObject(object, keys);
	};

	this.findHierarchyArrayInObject = function(object, hierarchyArray) {
		var val = object;
		for (var i = 0; i < hierarchyArray.length; i++) {
			var index = i;
			var key = hierarchyArray[i];
			if (key.indexOf("[") == 1 && key.indexOf("]") == key.length - 1) {
				var propertyName = key.substring(2, key.indexOf("="));
				var propertyValue = key.substring(
					key.indexOf("=") + 1,
					key.length - 1
				);
				// GDD-3853 - modified for mixed driver usages
				// var matchingOne = val.filter(function (item) {
				// 	return item[propertyName] == propertyValue;
				// });
				var matchingOne = val;
				var index = key.replace(
					"[" + propertyName + "=" + propertyValue + "]",
					""
				);

				if ((index != "") & (index != "0")) {
					var propertyIndex = parseInt(index);

					if (!isNaN(propertyIndex)) {
						val = matchingOne[propertyIndex];
						continue;
					}
				}

				val = matchingOne[0];

				if (val == null) {
					return null;
				}

				continue;
			}

			if (val[hierarchyArray[index]] == null) return null;

			val = val[hierarchyArray[index]];
		}
		return val;
	};

	this.updateValueInObject = function(object, value, pathString, delimiter) {
		var pathStringArray = pathString.split(delimiter);
		var lastKey = pathStringArray.pop();
		var val = object;
		for (var i = 0; i < pathStringArray.length; i++) {
			if (!val[pathStringArray[i]]) return;

			val = val[pathStringArray[i]];
		}
		val[lastKey] = value;
	};

	this.stringFormat = function(str) {
		var args = Array.prototype.slice.call(arguments, 1);

		return str.replace(/{(\d+)}/g, function(match, number) {
			return typeof args[number] != "undefined" ? args[number] : match;
		});
	};

	this.padNumber = function(num, width, padWith) {
		var padWith = padWith || "0",
			num = num + "";
		return num.length >= width
			? num
			: new Array(width - num.length + 1).join(padWith) + num;
	};

	this.clone = function(value) {
		return jQuery.extend({}, value);
	};

	this.deepClone = function(value) {
		return jQuery.extend(true, {}, value);
	};

	this.generateRandomChar = function() {
		var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
		return s.charAt(Math.floor(Math.random() * s.length));
	};

	this.generateRandomString = function(length) {
		var self = this;
		return new Array(length + 1)
			.join("0")
			.split("")
			.map(function() {
				return self.generateRandomChar();
			})
			.join("");
	};

	this.dispatchCustomEvent = function(event, detail) {
		dispatchCustomEvent(event, detail);
	};

	this.arrayFill = function(number, object) {
		if (!Array.prototype.fill) {
			//console.info('hi');
			Array.prototype.fill = function(value) {
				// Steps 1-2.
				if (this == null) {
					throw new TypeError("this is null or not defined");
				}

				var O = Object(this);

				// Steps 3-5.
				var len = O.length >>> 0;

				// Steps 6-7.
				var start = arguments[1];
				var relativeStart = start >> 0;

				// Step 8.
				var k =
					relativeStart < 0
						? Math.max(len + relativeStart, 0)
						: Math.min(relativeStart, len);

				// Steps 9-10.
				var end = arguments[2];
				var relativeEnd = end === undefined ? len : end >> 0;

				// Step 11.
				var final =
					relativeEnd < 0
						? Math.max(len + relativeEnd, 0)
						: Math.min(relativeEnd, len);

				// Step 12.
				while (k < final) {
					O[k] = value;
					k++;
				}

				// Step 13.
				return O;
			};
		}
		//console.info(Array(number).fill(object));
		return Array(number).fill(object);
	};

	this.generatePermutationsArray = function(options1, options2) {
		var permutations = [];
		angular.forEach(options1, function(option1) {
			angular.forEach(options2, function(option2) {
				permutations.push({
					option1: option1,
					option2: option2
				});
			});
		});
		return permutations;
	};

	this.getQueryStringByName = function(location, name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
		return results === null
			? ""
			: decodeURIComponent(results[1].replace(/\+/g, " "));
	};

	this.capitalize = function(token) {
		if (token) {
			return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
		}
	};

	this.compareDays = function(responseDate) {
		var expiredQuote;
		var today = moment().tz("Australia/Sydney");
		var quoteDate = moment(responseDate).tz("Australia/Sydney");
		var dateDiff = today.diff(quoteDate, "days");
		if (dateDiff >= 30) {
			return (expiredQuote = true);
		} else return (expiredQuote = false);
	};

	this.linkBuilder = function(generalLink) {
		var sessionProt = window.location.protocol;
		var sessionProtHost = window.location.host;
		var sessionProtPath = generalLink;
		var sessionProtURL =
			sessionProt + "//" + sessionProtHost + sessionProtPath;

		return sessionProtURL;
	};

	this.isUndefinedOrNull = function(arg) {
		if (angular.isUndefined(arg) || arg == null) {
			return true;
		}

		return false;
	};

	this.b64EncodeUnicode = function(str) {
		return btoa(
			encodeURIComponent(str).replace(
				/%([0-9A-F]{2})/g,
				function toSolidBytes(match, p1) {
					return String.fromCharCode("0x" + p1);
				}
			)
		);
	};

	this.b64DecodeUnicode = function(str) {
		return decodeURIComponent(
			atob(str)
				.split("")
				.map(function(c) {
					return (
						"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
					);
				})
				.join("")
		);
	};
}

angular.module("qbePortal").filter("capitalize", function() {
	return function(token) {
		if (token) {
			return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
		}
	};
});

angular.module("qbePortal").filter("sortalpha", function() {
	return function(list, prop) {
		return list.sort(function(a, b) {
			var nameA = a[prop].toUpperCase(); // ignore upper and lowercase
			var nameB = b[prop].toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});
	};
});

angular.module("qbePortal").filter("formatAddress", function() {
	return function(address) {
		function parseState(state) {
			return state.replace("AU_", "");
		}

		if (address)
			return (
				address.addressLine1 +
				" " +
				address.city +
				", " +
				parseState(address.state) +
				", " +
				address.postalCode
			);
	};
});

angular.module("qbePortal").filter("removeNonAlpha", function() {
	return function(token) {
		if (token) {
			var value = token.replace(/[^a-zA-Z0-9]+/g, " ");
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	};
});

angular.module("qbePortal").filter("splitJoinedWords", function() {
	return function(token) {
		if (token) {
			var value = token.replace(/([A-Z])/g, " $1");
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	};
});

angular.module("qbePortal").filter("styledCurrency", function($filter) {
	return function(token) {
		if (token) {
			var value = $filter("currency")(token)
				.toString()
				.split(".");
			return value;
		}
	};
});

angular.module("qbePortal").filter("useFilter", function($filter) {
	return function() {
		var filterName = [].splice.call(arguments, 1, 1)[0];
		return $filter(filterName).apply(null, arguments);
	};
});

angular.module("qbePortal").filter("calculateTotal", function() {
	return function(list, fieldName) {
		var total = null;
		angular.forEach(list, function(value) {
			total += parseFloat(value[fieldName]);
		});
		return total;
	};
});

angular.module("qbePortal").filter("wildcardReplace", [
	"Util",
	function(Util) {
		return function(inString, replaceWith) {
			var args = [].slice.call(arguments);
			if (args[0]) {
				if (typeof args[0] !== "string") {
					args[0] = args[0].$$unwrapTrustedValue();
				}

				return Util.stringFormat.apply(null, args);
			}
		};
	}
]);

angular.module("qbePortal").filter("driverInsured", [
	"Util",
	function(Util) {
		return function(inString, vehicleType) {
			var finalString;

			if (inString) {
				if (typeof inString !== "string") {
					inString = inString.$$unwrapTrustedValue();
				}

				finalString = inString;

				var replaceWith = "insured",
					replace = true;

				switch (vehicleType) {
					case undefined:
						replace = false;
						break;
					case "motorhome":
						replace = false;
						break;
					case "campervan":
						replace = false;
						break;
				}

				// if(vehicleType == undefined)
				// {
				// 	replace = false;
				// }

				if (replace) {
					finalString = inString
						.toLowerCase()
						.replace("driver", replaceWith);
				}
			}

			return finalString;
		};
	}
]);

angular.module("qbePortal").filter("booleanToYesNo", function($filter) {
	return function(token) {
		var value = null;
		if (typeof token === "string") {
			if (["yes", "no"].indexOf(token.toLowerCase()) != -1) {
				value = token.toLowerCase() === "yes";
			} else if (["true", "false"].indexOf(token.toLowerCase() != -1)) {
				value = token.toLowerCase() === "true";
			} else if (["1", "0"].indexOf(token) != -1) {
				value = String(token) === "1";
			}
		} else if (typeof token === "number") {
			if ([1, 0].indexOf(token) != -1) {
				value = token == 1;
			}
		} else if (typeof token === "boolean") {
			value = token;
		}

		return value ? "Yes" : "No";
	};
});

angular.module("qbePortal").filter("stringToSummaryDate", function($filter) {
	return function(token) {
		if (isNaN(Date.parse(token))) {
			var returnObject = null;

			var dateObject = {
				day: "",
				month: "",
				year: ""
			};

			if (token && token.length > 0 && token.length == 8) {
				dateObject.day = token.substr(0, 2);
				dateObject.month = token.substr(2, 2);
				dateObject.year = token.substr(4, 4);

				if (
					!isNaN(dateObject.day) &&
					!isNaN(dateObject.month) &&
					!isNaN(dateObject.year)
				) {
					return (
						dateObject.day +
						"/" +
						dateObject.month +
						"/" +
						dateObject.year
					);
				}
			}
			return null;
		}
		return token;
	};
});

angular.module("qbePortal").filter("showFslOnlyNsw", function() {
	return function(referenceDocuments, state) {
		return state != "AU_NSW"
			? referenceDocuments.filter(function(d) {
					return d.type != "fsl";
			  })
			: referenceDocuments;
	};
});

angular.module("qbePortal").filter("unique", function() {
	// we will return a function which will take in a collection
	// and a keyname
	return function(collection, keyname) {
		// we define our output and keys array;
		var output = [],
			keys = [];

		// we utilize angular's foreach function
		// this takes in our original collection and an iterator function
		angular.forEach(collection, function(item) {
			// we check to see whether our object exists
			var key = item[keyname];
			// if it's not already part of our keys array
			if (keys.indexOf(key) === -1) {
				// add it to our keys array
				keys.push(key);
				// push this item to our final output array
				output.push(item);
			}
		});
		// return our array which should be devoid of
		// any duplicates
		return output;
	};
});
